import React from "react";

interface OptionProps {
  step: number;
  title: string;
  description: string;
}

const RetailerOption: React.FC<OptionProps> = ({
  step,
  title,
  description,
}) => {
  return (
    <div className="wholesaler-option">
      <div className="option__list">
        <div className="option__list__header">
          <div className="wholesaler-option__step">
            <span>{step}</span>
          </div>
          <h3 className="wholesaler-option__title">{title}</h3>
        </div>
        <div className="wholesaler-option__content">
          <p className="wholesaler-option__description">{description}</p>
        </div>
      </div>
    </div>
  );
};

export default RetailerOption;
